@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.add-funds-modal {
  width: 560px;
}

.tabs {
  margin-top: 20px;

  .error-message {
    margin-bottom: 8px;
  }
}

.header-override {
  border-bottom: none;
}

.nonselected {
  padding-top: 4px;
}

.body-override {
  padding: 15px;
  border-top: 1px solid @settings-page--shipping-carriers-add-funds-modal--border-color;
  height: 280px;
  overflow: hidden;
}

.tab-content {
  font-size: 14px;
}

.currency-funds {
  height: 32px;
  max-width: 150px;
}

.label {
  padding: 8px 0 6px;
  font-weight: @semi-bold;
}

.max-funds-container {
  display: flex;
  align-items: center;
}

.max-funds-input {
  max-width: 50px;
  margin-right: 6px;
}

.make-default-checkbox {
  margin-top: 0.5em;
  margin-right: 8px;
}

.add-funds-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  & > button {
    margin-left: 8px;
  }
}

.transaction-fee-message {
  font-size: 13px;
  color: @settings-page--shipping-carriers-add-funds-modal-transaction-fee-message--text-color;
  margin: 16px;
}
